module.exports = __webpack_public_path__ + "static/media/training.1a5ac327.png";